import { render, staticRenderFns } from "./AlarmCause.vue?vue&type=template&id=67a21066&"
import script from "./AlarmCause.vue?vue&type=script&lang=js&"
export * from "./AlarmCause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports